import React from 'react';

const Modal = ({ childComponent: ChildComponent, onClose, ...childProps }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-content">
          <ChildComponent onClose={onClose} {...childProps} />
        </div>
      </div>
    </div>
  );
};

export default Modal;
